<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"

    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
      <!-- :src="barImage" -->
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="font-weight-regular display-2">
          <span class="logo-mini">{{ $t('ct') }}</span>
          <!-- <span class="logo-normal">{{ $t('tim') }}</span> -->
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list
      dense
      nav
    >
      <base-item-group :item="profile" />
    </v-list>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      nome: '',
      items: [
        {
          icon: 'mdi-home',
          title: 'home',
          to: '/',
        },
        {
          group: '/cadastros',
          icon: 'mdi-file-cabinet',
          title: 'Cadastros',
          children: [
            {
              icon: 'mdi-cow',
              title: 'pessoaPesquisa',
              to: 'pessoaPesquisaForm',
            }, 
            {
              icon: 'mdi-cow',
              title: 'animalPesquisa',
              to: 'animalPesquisaForm',
            },   
            {
              icon: 'mdi-clipboard-edit-outline',
              title: 'tipoFichaPesquisa',
              to: 'tipoFichaPesquisaForm',
            },    
            {
              icon: 'mdi-map-marker-multiple-outline',
              title: 'localPesquisa',
              to: 'localPesquisaForm',
            },
            {
              icon: 'mdi-robot-outline',
              title: 'roboPesquisa',
              to: 'roboPesquisaForm',
            },
          ]
        },
        {
          icon: 'mdi-clipboard-edit-outline',
          title: 'fichaPesquisa',
          to: '/fichaPesquisaForm',
        },
        {
          icon: 'mdi-clipboard-text-outline',
          title: 'chamadaForm',
          to: '/chamadaForm',
        },
        {
          icon: 'mdi-calendar',
          title: 'agendaForm',
          to: '/agendaForm',
        },
        {
          icon: 'mdi-calendar',
          title: 'tarefaPesquisaForm',
          to: '/tarefaPesquisaForm',
        },        
      ],
    }),
    mounted () {
      if (localStorage.usuario) {
        this.nome = localStorage.usuario
      }
      else{
        this.nome = this.$t('avatar')
      }
    },  
    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: false,
          group: '',
          title: this.nome,
          children: [
            // {
            //   to: 'cadastro',
            //   title: this.$t('cadastro'),
            // },
            {
              to: 'configuracoes',
              title: this.$t('configuracoes'),
            },
          ],
        }
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      },
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
    },
  }
</script>
